module.exports = __webpack_public_path__ + "img/paylines-high.a08664eb.svg";